"use client";

import { BBLoader } from "@/lib";
import { persistor, store } from "@/store";
import { setStorageLoadedTrue } from "@/store/auth/authSlice";
import BBThemeProvider from "@/theme/BBThemeProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import ToastDispatchBridge from "./ToastDispatchBridge";

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PersistGate
          loading={<BBLoader />}
          persistor={persistor}
          onBeforeLift={() => {
            store.dispatch(setStorageLoadedTrue());
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <BBThemeProvider>
              <ToastDispatchBridge />
              {children}
            </BBThemeProvider>
          </LocalizationProvider>
        </PersistGate>
      </QueryClientProvider>
    </Provider>
  );
};

export default AppProvider;
